import React from 'react';
import ModalReportSelect_ReportPreview from "./report-preview";
import Report from "../../../../../core/model2/report/report";


type Props = {
    group           : any
    onSelectReport  : callback
}

export default function ModalReportSelect_GroupedReportPreview(props: Props) {

    return (
        <>
            <div className="ui5-title-small txt-bold">
                {props.group.title}
            </div>

            <div className="flex-row-left-top flex-wrap">
                {props.group.reports.map((report: Report, key: number)=>{
                    return <ModalReportSelect_ReportPreview key            = {key}
                                                            report         = {report}
                                                            onSelectReport = {props.onSelectReport}/>
                })}
            </div>
        </>
    )
}
